/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mediathèque
 */

(function ($) {
    'use strict';
    var $content = $('#content:not(.js-inhibate)');
    $('[name="MEDIA_FILE"]', $content).on(
        'change keyup', function (e) {
            e.preventDefault();
            if (checkFileExt('MEDIA')) {
                $('input[name="ACTION"]').val('CONTROLER_RESSOURCE');
                $(this).closest('form').submit();
            }
        });
    $('.js-change-source').on(
        'click', function (e) {
            var $this = $(this);
            e.preventDefault();
            $('input[name="ACTION"]').val('AJOUTER');
            $('input[name="IS_LOCAL"]').val($this.attr('data-local') || false);
            $this.closest('form').submit();
        });
    $('.js-media-list__edit-button, .js-media-list__container', $content).on(
        'click', function () {
            var $this = $(this);
            $('input[name="ACTION"]').val($this.attr('data-action'));
            $('input[name="ID_MEDIA"]').val($this.attr('data-idmedia'));
            $this.closest('form').submit();
        });
    $('.js-media-list__delete-button', $content).on(
        'click', function () {
            var $button = $(this);
            $('<div>').html(LOCALE_BO.media.actions.delete.confirm).dialog(
                {
                    buttons: [{
                        text: LOCALE_BO.ok,
                        click: function () {
                            $(this).dialog('close');
                            $('input[name="ACTION"]').val('SUPPRIMER');
                            $('input[name="ID_MEDIA"]').val($button.attr('data-idmedia'));
                            $button.closest('form').submit();
                        }
                    },
                        {
                            text: LOCALE_BO.fermer,
                            click: function () {
                                $(this).dialog('close');
                            }
                        }],
                    title: LOCALE_BO.confirmer
                });
        });
    $('.js-thumbnail__delete-button', $content).on(
        'click', function () {
            var $imgVignette = $('#img_vignette'),
                $divVignette = $('#div_vignette');
            $('input[name="URL_VIGNETTE"]').val('');
            $('input[name="VIGNETTE"]').val('');
            if ($imgVignette.length > 0) {
                $imgVignette.attr('src', '');
                $divVignette.replaceWith($divVignette.clone(true)).html('');
            }
        });
    $('.js-tabs-medias').tabs({});
    // Gestion du champ "Légende" et de la checkbox "Image décorative ne nécessitant pas de légende" dans l'onglet "description"
    // de la médiathèque (description.jsp) et dans l'écran de saisie d'un média via la toolbox (media_selection.jsp).
    var checkboxes = document.querySelectorAll('input[id^="CB_LEGENDE_"]');
    var inputLegends = document.querySelectorAll('input[id^="LEGENDE"]');
    //init
    if (checkboxes.length !== 0) {
        requiredAndDisabledAllLegend(checkboxes[0].checked);
        checkAllLegend(checkboxes[0].checked);
    }
    // synchronisation de la checkbox "Image décorative ne nécessitant pas de légende" sur tous les onglets de langues.
    [].forEach.call(checkboxes, function (checkbox) {
        checkbox.addEventListener('change', function () {
            if (this.checked) {
                checkAllLegend(true);
                requiredAndDisabledAllLegend(true);
            } else {
                checkAllLegend(false);
                requiredAndDisabledAllLegend(false);
            }
        });
    });

    // Coche ou décoche la checkbox "Image décorative ne nécessitant pas de légende".
    function checkAllLegend(checked) {
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = checked;
        }
    }

    //Active ou désactive le champ de légende et met en place l'attribut "required" du champ de légende.
    function requiredAndDisabledAllLegend(disabled) {
        // required seulement sur la langue par défaut
        var length = inputLegends.length;
        if (disabled === true) {
            inputLegends[length - 1].removeAttribute('required');
        } else {
            inputLegends[length - 1].setAttribute('required', 'required');
        }
        inputLegends.forEach(function (e) {
            if (disabled === true) {
                e.value = '';
            }
            e.disabled = disabled;
        });
    }

    var enregistrer_media = document.querySelector('#ENREGISTRER_MEDIA');
    // Gestion de l'affichage de l'erreur "La légende est obligatoire." sur la popup de saisie
    // des médias.
    if (enregistrer_media) {
        enregistrer_media.addEventListener('click', function legendeObligatoire(evt) {
            if (window.top !== window.self && !checkboxes[0]?.checked && !isLegendeRenseignee()) {
                document.querySelector('.js-message-erreur').innerHTML = '<p class="message alert alert-danger">' + LOCALE_BO.ckeditor.plugins.kimage.erreur_legende + '</p>';
                evt.preventDefault();
            } else {
                return true;
            }
        });
    }

    // vérifie si la légende est renseignée dans une langue.
    function isLegendeRenseignee() {
        var estRenseignee = false;
        inputLegends.forEach(function (inputLegend) {
            if (inputLegend.value !== '') {
                estRenseignee = true;
            }
        });
        return estRenseignee;
    }
})(jQuery.noConflict());
